// Environment-based API configuration
const API_URLS = {
  production: 'https://2y6ckydv6g7hu7d632dnnkcmxa0ivvnp.lambda-url.us-east-1.on.aws/', // prod (us-east-1)
  beta: 'https://sfesise5w5b6jyhsr5zk7cdhsm0bkrvy.lambda-url.us-west-2.on.aws/', // beta (us-west-2)
};

// Get current environment - defaults to production if not set
const getCurrentEnvironment = () => {
  // You can override with REACT_APP_CHAT_API_ENV for more control
  return process.env.REACT_APP_CHAT_API_ENV || 'production';
};

// Automatically select the correct API URL based on environment
export const API_URL = API_URLS[getCurrentEnvironment()] || API_URLS.production;

export const X_URL = 'https://x.com/dictionarychat';

export const Version = {
  MAJOR: 1,
  MINOR: 3,
  PATCH: 20,
};



